import * as React from 'react';
import { QuantitySelector } from '@grandvisionhq/common';
import { getCalculatedMaximumQuantity } from '@grandvisionhq/utils';
import '../../../context/Cart/context.js';
import '@swc/helpers';
import '@grandvisionhq/graphql';
import '@grandvisionhq/state';
import '@grandvisionhq/svc-tealium/events';
import { useCartSettings } from '../../../context/CartSettings/context.js';
import '../../../models/add-to-cart/add-to-cart.js';
import '../../../models/cart/cart.js';
import '../../../models/checkoutState/checkoutState.js';
import '../../../utils/cart-count-var.js';
import '../../../utils/cart-id-var.js';
import '@grandvisionhq/commercetools';
import '../../../utils/get-unrecoverable-validation-errors.js';
import '../../../models/line-item/prescription-glasses.js';
import '../../../utils/get-failure-error-codes.js';
import '../../../utils/get-validation-errors-by-line-item.js';
import '@grandvisionhq/lib-visuals';
import '../../../operations/fragments/cart-details.js';
import '../../../operations/fragments/cart-validation-errors.js';
import '../../../operations/fragments/recover-inactive-cart-failure.js';
import '../../../operations/fragments/recover-inactive-cart-result.js';
import '../../../operations/mutations/add-cart-line-items.js';
import '../../../operations/mutations/add-cart-voucher-codes.js';
import '../../../operations/mutations/create-cart.js';
import '../../../operations/mutations/create-cart-from-instant-checkout-link.js';
import '../../../operations/mutations/create-cart-from-order.js';
import '../../../operations/mutations/duplicate-cart-line-items.js';
import '../../../operations/mutations/remove-cart-voucher-codes.js';
import '../../../operations/mutations/remove-cart-line-items.js';
import '../../../operations/mutations/update-cart-line-items.js';
import '../../../operations/mutations/recover-inactive-cart.js';
import '../../../operations/queries/get-cart.js';
import '../../../operations/queries/get-total-line-items.js';
import '../../../operations/queries/get-cart-estimated-delivery.js';
import '@grandvisionhq/analytics';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-monetate';
import '@grandvisionhq/payments';
import '../../../mappers/analytics/tealium/line-item-to-tealium-product.js';
import '@grandvisionhq/frk-routing';
import { useUpdateLineItemQuantity } from '../../../hooks/use-update-line-item-quantity.js';

const UpdateLineItemContainer = ({ lineItem , availableQuantity , isDisabled ,  })=>{
    const { minimumQuantity , maximumQuantity  } = useCartSettings();
    const [updateItemQuantity] = useUpdateLineItemQuantity(lineItem);
    const handleDecreaseQuantity = React.useCallback(()=>{
        updateItemQuantity(lineItem.quantity - 1);
    }, [
        lineItem.quantity,
        updateItemQuantity
    ]);
    const handleIncreaseQuantity = React.useCallback(()=>{
        updateItemQuantity(lineItem.quantity + 1);
    }, [
        lineItem.quantity,
        updateItemQuantity
    ]);
    return /*#__PURE__*/ React.createElement(QuantitySelector, {
        onDecreaseQuantity: handleDecreaseQuantity,
        onIncreaseQuantity: handleIncreaseQuantity,
        minimumQuantity: minimumQuantity,
        maximumQuantity: getCalculatedMaximumQuantity(maximumQuantity, availableQuantity, lineItem.allowBackOrder),
        quantity: lineItem.quantity,
        isDisabled: isDisabled,
        "data-t": "quantity-selector",
        disableAnimation: true
    });
};

export { UpdateLineItemContainer };
//# sourceMappingURL=UpdateLineItemContainer.js.map
